import { render, staticRenderFns } from "./sendSampleList.vue?vue&type=template&id=7a647ff0&scoped=true"
import script from "./sendSampleList.vue?vue&type=script&lang=js"
export * from "./sendSampleList.vue?vue&type=script&lang=js"
import style0 from "./sendSampleList.vue?vue&type=style&index=0&id=7a647ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a647ff0",
  null
  
)

export default component.exports